import { gql } from '@apollo/client';

const GET_CART = gql`
  query GET_CART {
    cart {
      contents {
        nodes {
          key
          product {
            node {
              id
              productId: databaseId
              name
              type
              onSale
              slug
              image {
                id
                sourceUrl
                altText
                title
                cloudinaryResource {
                  public_id
                  version
                  url_suffix
                  resource_type
                  delivery_type
                }
              }
              ... on SimpleProduct {
                price(format: FORMATTED)
                regularPrice(format: FORMATTED)
              }
            }
          }
          variation {
            node {
              id
              productId: databaseId
              name
              description
              type
              onSale
              price(format: FORMATTED)
              regularPrice(format: FORMATTED)
              image {
                id
                sourceUrl
                cloudinaryResource {
                  public_id
                  version
                  url_suffix
                  resource_type
                  delivery_type
                }
              }
            }
            attributes {
              id
              name
              value
            }
          }
          quantity
          total
          subtotal
          subtotalTax
        }
      }
      appliedCoupons {
        code
        discountAmount
        discountTax
      }
      subtotal
      subtotalTax
      shippingTax
      shippingTotal
      total
      totalTax
      feeTax
      feeTotal
      discountTax
      discountTotal
    }
  }
`;

export default GET_CART;
